import api from '../common/api';

const basePath = '/distributions';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(distribution) {
    return api.post(basePath, distribution);
  },
  get(distributionId, params = {}) {
    return api.get(`${basePath}/${distributionId}`, { params });
  },
  update(distributionId, distribution) {
    return api.put(`${basePath}/${distributionId}`, distribution);
  },
  exportItems(distributionId) {
    return api.get(`${basePath}/${distributionId}/items/export`, { responseType: 'blob' });
  }
};



// WEBPACK FOOTER //
// ./src/services/distributionService.js